@import (reference) '../../../../constants/spacing.module.less';

.voided-label-expander {
  border-bottom: none;
}

.voided-label-expander-header {
  background: var(--default--background-color--16);
  color: var(--light--text-color--1);
  padding: @space-16;

  :global div.collapsible-list-caret > svg {
    fill: var(--light--icon--fill-color--1);
  }
}

.voided-label-expander-content {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
  background: var(--default--background-color--16);
  padding: @space-0 @space-16 @space-16 @space-16;
}

.voided-label-open-expander-header {
  border-bottom: none;
}

.voided-label-expander-header-content {
  padding: @space-0;
}

.voided-label-expander-section-title {
  color: var(--light--text-color--1);
}
